import { render, staticRenderFns } from "./firm-admin-column.vue?vue&type=template&id=0f1f1e8c&scoped=true&"
import script from "./firm-admin-column.vue?vue&type=script&lang=js&"
export * from "./firm-admin-column.vue?vue&type=script&lang=js&"
import style0 from "./firm-admin-column.vue?vue&type=style&index=0&id=0f1f1e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1f1e8c",
  null
  
)

export default component.exports